import { Reducer } from 'redux';

import { detectResolution } from './screenUtils';

// Actions

export const changeResolutionAction = (state: ScreenState) => ({
  type: 'CHANGE_SCREEN_RESOLUTION' as const,
  state,
});

type ScreenAction = ReturnType<typeof changeResolutionAction>;

// Reducer

type ScreenState = {
  readonly resolutionIndex: number;
  readonly isMobile: boolean;
  readonly isTablet: boolean;

  readonly verticalResolutionIndex: number;
};

export const screenReducer: Reducer<ScreenState, ScreenAction> = (
  state = detectResolution(),
  action
): ScreenState => {
  switch (action.type) {
    case 'CHANGE_SCREEN_RESOLUTION':
      return action.state;
    default:
      return state;
  }
};
